import { motion, useMotionValue, useSpring } from "framer-motion";

export const TiltCard = ({ children, className = "", max = 7, ...rest }) => {
  const rx = useSpring(useMotionValue(0), { stiffness: 150, damping: 18 });
  const ry = useSpring(useMotionValue(0), { stiffness: 150, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    e.currentTarget.style.setProperty("--mx", `${px * 100}%`);
    e.currentTarget.style.setProperty("--my", `${py * 100}%`);
    ry.set((px - 0.5) * max * 2);
    rx.set((0.5 - py) * max * 2);
  };
  const onLeave = () => { rx.set(0); ry.set(0); };

  return (
    <div style={{ perspective: 1000 }} className={className}>
      <motion.div
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        whileHover={{ y: -6 }}
        transition={{ type: "spring", stiffness: 200, damping: 20 }}
        className="glow-border group relative h-full rounded-3xl"
        {...rest}
      >
        {children}
      </motion.div>
    </div>
  );
};
